module.exports = __webpack_public_path__ + "b7ffafc9fbd384a719666323f2a7b693.svg";